import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "layout-px-spacing" };
const _hoisted_2 = { class: "row layout-top-spacing" };
const _hoisted_3 = { class: "col-xl-12 col-lg-12 col-sm-12 layout-spacing" };
const _hoisted_4 = { class: "panel br-6" };
const _hoisted_5 = { class: "custom-panel-header d-flex justify-content-between align-items-center p-3" };
const _hoisted_6 = { class: "header-actions" };
const _hoisted_7 = { class: "p-3 pt-0" };
const _hoisted_8 = { class: "table-responsive mt-3" };
const _hoisted_9 = {
    class: "table table-hover",
    style: { "width": "100%" }
};
const _hoisted_10 = { class: "d-flex align-items-center" };
const _hoisted_11 = { class: "page-icon me-3" };
const _hoisted_12 = { class: "fw-bold d-block text-capitalize" };
const _hoisted_13 = { class: "badge bg-light-info text-info smaller" };
const _hoisted_14 = { class: "form-check form-switch custom-switch-v1" };
const _hoisted_15 = ["id", "onUpdate:modelValue", "onChange"];
const _hoisted_16 = ["for"];
const _hoisted_17 = { class: "text-center" };
const _hoisted_18 = { class: "d-flex justify-content-center gap-2" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                            _createElementVNode("h4", { class: "m-0 fw-bold" }, "Gestion des Pages"),
                            _createElementVNode("p", { class: "text-muted small mb-0" }, "Gérez le contenu et la visibilité des pages de votre site web pour votre franchise.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                                class: "btn btn-outline-primary btn-sm",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.refreshPages && _ctx.refreshPages(...args)))
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1),
                                    _createTextVNode(" Actualiser ", -1)
                                ]))])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                                _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Page (Type)"),
                                        _createElementVNode("th", null, "Slug / URL"),
                                        _createElementVNode("th", null, "Statut"),
                                        _createElementVNode("th", { class: "text-center" }, "Actions")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: page.id,
                                            class: _normalizeClass({ 'opacity-50': !page.isActive })
                                        }, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass(_ctx.getPageIcon(page.canonicalType))
                                                        }, null, 2)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getPageTitle(page)), 1),
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString(page.canonicalType), 1)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("code", null, "/" + _toDisplayString(page.slug), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        id: 'switch-' + page.id,
                                                        "onUpdate:modelValue": ($event) => ((page.isActive) = $event),
                                                        onChange: ($event) => (_ctx.togglePageStatus(page))
                                                    }, null, 40, _hoisted_15), [
                                                        [_vModelCheckbox, page.isActive]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label pr-2",
                                                        for: 'switch-' + page.id
                                                    }, _toDisplayString(page.isActive ? 'Active' : 'Masquée'), 9, _hoisted_16)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'VabenePageFormPage', params: { action: 'edit', id: page.id } },
                                                        class: "btn btn-sm btn-outline-primary",
                                                        title: "Modifier (Classique)"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                                _createElementVNode("i", { class: "ri-edit-2-line" }, null, -1)
                                                            ]))]),
                                                        _: 1
                                                    }, 8, ["to"]),
                                                    (page.slug === 'about' || page.canonicalType === 'FEEDBACK')
                                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                                            key: 0,
                                                            to: { name: 'VabenePageStudioPage', params: { id: page.id } },
                                                            target: "_blank",
                                                            class: "btn btn-sm btn-success px-3 rounded-pill shadow-sm",
                                                            title: "Ouvrir dans le Design Studio (Shopify Style)"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                                    _createElementVNode("i", { class: "ri-palette-line me-1" }, null, -1),
                                                                    _createTextVNode(" Studio ", -1)
                                                                ]))]),
                                                            _: 1
                                                        }, 8, ["to"]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ], 2));
                                    }), 128)),
                                    (_ctx.loading)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[5] || (_cache[5] = [
                                                _createElementVNode("td", {
                                                    colspan: "4",
                                                    class: "text-center py-5"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "spinner-border text-primary",
                                                        role: "status"
                                                    }, [
                                                        _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                                                    ])
                                                ], -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (!_ctx.loading && _ctx.pages.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[6] || (_cache[6] = [
                                                _createElementVNode("td", {
                                                    colspan: "4",
                                                    class: "text-center py-5"
                                                }, [
                                                    _createElementVNode("p", { class: "text-muted mb-0" }, "Aucune page trouvée pour votre franchise.")
                                                ], -1)
                                            ]))]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
